const popup = () => {
  const target = document.querySelectorAll('.p-snap__img')
  const closeTarget = document.querySelectorAll('.p-popup__bg')
  const closeBtn = document.querySelectorAll('.p-popup__close')
  target.forEach(value => {
    value.addEventListener('click', () => {
      document.querySelector('.p-snap').classList.add('active')
      value.nextElementSibling.classList.add('active')
    })
  })
  closeTarget.forEach(value => {
    value.addEventListener('click', () => {
      document.querySelector('.p-snap').classList.remove('active')
      value.closest('.p-popup').classList.remove('active')
    })
  })
  closeBtn.forEach(value => {
    value.addEventListener('click', () => {
      document.querySelector('.p-snap').classList.remove('active')
      value.closest('.p-popup').classList.remove('active')
    })
  })
}

window.addEventListener('DOMContentLoaded', () => {
  popup()

  // スライダー
  var carouselElement01 = document.querySelector('.slider01');
  var carouselElement02 = document.querySelector('.slider02');
  var carouselElement03 = document.querySelector('.slider03');
  var opt = {
    wrapAround: true,
    pageDots: false,
    autoPlay: true,
    pauseAutoPlayOnHover: false,
  }
  var flkty01 = new Flickity(carouselElement01, opt)
  var flkty02 = new Flickity(carouselElement02, opt)
  var flkty03 = new Flickity(carouselElement03, opt)
  flkty01.on( 'settle', function() {flkty01.playPlayer()});
  flkty02.on( 'settle', function() {flkty02.playPlayer()});
  flkty03.on( 'settle', function() {flkty03.playPlayer()});
})
